function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.366 7.188l-5.5-3.344A.751.751 0 004.75 4.5V11c0 .575.619.931 1.116.656l5.5-3.156a.752.752 0 000-1.313zm4.134.562A7.749 7.749 0 007.75 0 7.749 7.749 0 000 7.75a7.749 7.749 0 007.75 7.75 7.749 7.749 0 007.75-7.75zm-14 0A6.248 6.248 0 017.75 1.5 6.248 6.248 0 0114 7.75 6.248 6.248 0 017.75 14 6.248 6.248 0 011.5 7.75z",
  fill: "#0D5A91",
  fillOpacity: 0.5
});

var SvgBespokenIconPlayAudio = function SvgBespokenIconPlayAudio(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref);
};

export default SvgBespokenIconPlayAudio;